import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { bmxurl, getAccess } from 'src/globals';
import { users_returndata } from 'src/types/user_returndata';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-reportpage',
  templateUrl: './reportpage.component.html',
  styleUrls: ['./reportpage.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReportpageComponent implements OnInit {

  ReportInfo: string = "";
  ShowPaymentReportButton: boolean = false;
  ShowCustomerReportButton: boolean = false;
  ShowExtrasReportButton: boolean = false;
  ShowBQReportButton: boolean = false;
  ShowBookingListReportButton: boolean = false;
  ShowBookingListCreatedReportButton: boolean = false;
  ShowSalesReportButton: boolean = false
  ShowItineraryReportButton: boolean = false;
  ShowAdmissionReportButton: boolean = false;
  ShowAdmissionValueReportButton: boolean = false;
  AccessAllowed: boolean = false; 
  CompletedLoading: boolean = true;
  httpResponse: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    private messageService: MessageService
  ) 
  {}

  ngOnInit(): void {
  
      let userid = localStorage.getItem("SmartUserID");
  
      this.http.get(bmxurl + "User/" + userid).subscribe(response => {
        this.httpResponse =  (response as users_returndata)
        if(this.httpResponse.succeeded)
        {
          let user = this.httpResponse.data;
  
          if(getAccess("REPORTS", user)){
            this.AccessAllowed = true;
          }
  
          this.CompletedLoading = true;
  
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
      });
  }

  doPaymentsReport(){
    this.router.navigateByUrl("/paymentreport");
  }

  showPaymentText()
  {
    this.ShowReportButton("Payments");
    this.ReportInfo = "<h4>Payments Report</h4><br>The Payment Report shows all payments made between the dates chosen.  <BR><BR>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doCustomerReport(){
    this.router.navigateByUrl("/customerreport");
  }

  showCuwtomerText(){
    this.ShowReportButton("Customers");
    this.ReportInfo = "<h4>Customer Report</h4><br>The Customer Report shows a list of all customers who have ever visited the venue.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doExtrasReport(){
    this.router.navigateByUrl("/extrasreport");
  }

  showExtrasText(){
    this.ShowReportButton("Extras");
    this.ReportInfo = "<h4>Extras Report</h4><br>The Extras Report shows all Extras purchased by customers between the dates chosen. <br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doBQReport(){
    this.router.navigateByUrl("/bookinganswersreport");
  }

  showBQText(){
    this.ShowReportButton("BQ");
    this.ReportInfo = "<h4>Booking Questions Report</h4><br>The Booking Questions Report shows all booking questions for bookings between the dates chosen.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doBookingListReport(){
    this.router.navigateByUrl("/bookinglistreport");
  }

  showBLText(){
    this.ShowReportButton("BookingList");
    this.ReportInfo = "<h4>Booking List Report</h4><br>The Booking List Report shows all bookings between the dates chosen.  The report gives you a break down of the admissions, extras and allergies for the bookings.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doBookingListCreatedReport(){
    this.router.navigateByUrl("/bookinglistcreatedreport");
  }

  showBLCText(){
    this.ShowReportButton("BookingListCreated");
    this.ReportInfo = "<h4>Booking List Report (Created Date)</h4><br>The Booking List Report (Created Date) shows all bookings created between the dates chosen.  The report gives you a break down of the admissions, extras and allergies for the bookings.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doSalesReport(){
    this.router.navigateByUrl("/salesreport");
  }

  showSalesText(){
    this.ShowReportButton("Sales");
    this.ReportInfo = "<h4>Sales Report</h4><br>The Sales Report gives you a list of all bookings sub totaled by package.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doItineraryReport(){
    this.router.navigateByUrl("/itineraryreport");
  }

  showItineraryText(){
    this.ShowReportButton("Itinerary");
    this.ReportInfo = "<h4>Itinerary Report</h4><br>The Itinerary Report shows a section for every resource in use between the dates chosen, broken down by timeslot within each one.  A booking appears under each resource its itinerary uses, with the customer's contact details, the full itinerary, the admissions and the waivers signed.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doAdmissionReport(){
    this.router.navigateByUrl("/admissionreport");
  }

  showAdmissionText(){
    this.ShowReportButton("Admission");
    this.ReportInfo = "<h4>Admission Report</h4><br>The Admission Report shows all bookings between the dates chosen, with a column for each admission type and how many of it the booking has.  Only the admission types actually sold in the period are shown, and each column is totalled at the foot.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doAdmissionValueReport(){
    this.router.navigateByUrl("/admissionvaluereport");
  }

  showAdmissionValueText(){
    this.ShowReportButton("AdmissionValue");
    this.ReportInfo = "<h4>Admissions Value Report</h4><br>The Admissions Value Report shows all bookings between the dates chosen, with a column for each admission type and what it was worth on the booking, plus the value of all the booking's admissions together.  Only the admission types actually sold in the period are shown, and each column is totalled at the foot.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doOutstandingBalanceReport(){
    this.router.navigateByUrl("/outstandingbalancereport");
  }

  showOutstandingBalanceText(){
    this.ShowReportButton("OutstandingBalance");
    this.ReportInfo = "<h4>Outstanding Balance Report</h4><br>The Outstanding Balance Report is the Booking List Report cut down to the bookings that still have money owing on them.  It shows the same details for each booking, and totals the guests, the booking values and the amount outstanding at the foot.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  ShowReportButton(requiredReport: string){
    this.ShowPaymentReportButton = false;
    this.ShowCustomerReportButton = false;
    this.ShowExtrasReportButton = false;
    this.ShowBQReportButton = false;
    this.ShowBookingListReportButton = false;
    this.ShowBookingListCreatedReportButton = false;
    this.ShowSalesReportButton = false;
    this.ShowItineraryReportButton = false;
    this.ShowAdmissionReportButton = false;
    this.ShowAdmissionValueReportButton = false;

    if (requiredReport == "Payments"){
      this.ShowPaymentReportButton = true;
    }

    if (requiredReport == "Customers"){
      this.ShowCustomerReportButton = true;
    }

    if (requiredReport == "Extras"){
      this.ShowExtrasReportButton = true;
    }

    if (requiredReport == "BQ"){
      this.ShowBQReportButton = true;
    } 

    if (requiredReport == "BookingList"){
      this.ShowBookingListReportButton = true;
    }

    if (requiredReport == "BookingListCreated"){
      this.ShowBookingListCreatedReportButton = true;
    }

    if (requiredReport == "Sales"){
      this.ShowSalesReportButton = true;
    }

    if (requiredReport == "Itinerary"){
      this.ShowItineraryReportButton = true;
    }

    if (requiredReport == "Admission"){
      this.ShowAdmissionReportButton = true;
    }

    if (requiredReport == "AdmissionValue"){
      this.ShowAdmissionValueReportButton = true;
    }
  }
}


